import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=15b84c54&"
import script from "./Columns.vue?vue&type=script&lang=ts&"
export * from "./Columns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports